<template>
  <v-autocomplete
    outlined
    density="compact"
    v-model="inputValue"
    v-bind:items="schoolTypes"
    v-bind:item-title="(item) => objectTranslator(item, 'SCHOOL_TYPE_NAME')"
    v-bind:item-value="(item) => item.SCHOOL_TYPE_ID"
    v-bind:rules="inputRules"
    variant="outlined"
  ></v-autocomplete>
</template>
<script>
import { objectTranslator } from "../../helper/translator";
import validator from "@/helper/validator";

export default {
  name: "SchoolType",
  props: {
    modelValue: String,
  },

  data: () => ({
    inputRules: [validator.required],
  }),

  methods: {
    objectTranslator,

    async fetch_data() {
      this.$store.dispatch("ref/getSchoolTypes");
    },
  },

  computed: {
    schoolTypes() {
      return this.$store.state.ref.schoolTypes;
    },
    inputValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },

  created() {
    this.fetch_data();
  },
};
</script>
